import styles from "@/components/error-popup.module.css";
import PopupCloseButton from "@/components/popup-close-button";
import * as signals from "@/signals";
import clsx from "clsx";
import { t } from "i18next";
import { JSX } from "react";

function ErrorPopup(): JSX.Element {
	const closeErrorPopup = (): void => {
		signals.errorMessage.value = null;
	};

	if (!signals.errorMessage.value) {
		return <></>;
	}
	return (
		<div className={clsx(styles["error"], "fade-in")}>
			<header className={styles["error-title"]}>
				{t("error")}
				<PopupCloseButton onClick={closeErrorPopup} />
			</header>
			<div>{signals.errorMessage.value}</div>
		</div>
	);
}

export default ErrorPopup;
